import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment.prod";

@Injectable({
    providedIn: "root",
})
export class NotificationsService {
    constructor(private http: HttpClient) {}

    getNotifications(page: number) {
        return this.http.get(
            `${environment.api}/api/customer/notifications?page=${page}`
        );
    }
    markAsRead() {
        return this.http.post(
            `${environment.api}/api/customer/notifications/read`,
            {}
        );
    }
}
